import { IOpenAuthModalParameters } from 'shared/repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';

import { ensureHeaderMicrofrontend } from '../../microfrontend';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v3/open-auth-modal/', parameters);
}
